import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class customValidationService {
  static checkLimit(min: number): ValidatorFn {
    return (control: FormControl): { [key: string]: any } => {
      if (isNaN(control.value)) return { 'customValidator': true };
      if (control.value !== 0 && control.value !== min) return { 'customValidator': true };
      else return null;
    }
  };

  static noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').length === 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }

  static cannotContainSpace(control: FormControl) {
    return (control.value || '').trim().length? null : { 'whitespace': true };
  }
}

